<template>
  <div class="flex min-h-screen flex-col bg-gray-50 dark:bg-gray-900">
    <!-- Header with same structure as AppNavbar -->
    <nav
      class="sticky top-0 z-50 border-b border-gray-200 bg-white/80 backdrop-blur-sm dark:border-gray-700 dark:bg-gray-900">
      <div class="mx-auto flex max-w-screen-xl flex-wrap items-center justify-between px-2">
        <LocaleLink to="/" class="flex items-center space-x-3 rtl:space-x-reverse">
          <div class="mt-2 whitespace-nowrap text-2xl font-semibold dark:text-white">
            <NuxtImg src="/logo_white.svg" alt="InMyResume Logo" width="200" height="42"
              class="hidden pt-2 dark:block" />
            <NuxtImg src="/logo.svg" alt="InMyResume Logo" width="200" height="42" class="block pt-2 dark:hidden" />
          </div>
        </LocaleLink>
        <div class="flex items-center space-x-4">
          <NavbarColorModeSwitcher />
        </div>
      </div>
    </nav>

    <!-- Main content area -->
    <main class="flex flex-1 items-center justify-center">
      <div class="w-full">
        <slot />
      </div>
    </main>

    <!-- Footer with same structure as AppFooter -->
    <AppFooter />
  </div>
</template>

<style>
@media print {
  body {
    background: white !important;
  }

  .print\:hidden {
    display: none !important;
  }

  header {
    display: none !important;
  }

  footer {
    display: none !important;
  }
}
</style>
